import { Dropdown } from "primereact/dropdown";
import "./styles.css";

function DropDown({
  id,
  name,
  label,
  colSpan,

  options = [],
  value,
  onChange,
  filter = true,
  placeholder,
  optionLabel,
  optionValue,
  showClear = false,
  itemTemplate,
  valueTemplate,

  required = false,
  error,
  touched,
  helpText,
  onBlur,
  filterBy,

  className = "",
  disabled = false,
}) {
  const hasError = touched && !!error;

  return (
    <div className={`flex flex-col gap-1.5 md:col-span-${colSpan}`}>

      <label
        htmlFor={id}
        className={`text-sm font-medium ${hasError ? "text-destructive" : "text-foreground/80"} `}>
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </label>

      <Dropdown
        id={id}
        name={name}
        filterInputAutoFocus
        value={value}
        onChange={onChange}
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        filter={filter}
        filterBy={filterBy}
        showClear={showClear}
        disabled={disabled}
        onBlur={onBlur}
        placeholder={placeholder}
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        className={`
          w-full
          text-sm
          transition
          rounded-sm
          ${disabled && "bg-gray-50 cursor-not-allowed"}

          ${hasError
            ? "border border-red-500 focus:ring-1 focus:ring-red-500 p-invalid"
            : "border border-blue-300 focus:ring-1 focus:ring-blue-500"
          }

          ${className}
        `}
      />

      {/* Mensagem abaixo */}
      {hasError ? (
        <span className="text-xs text-destructive">{error}</span>
      ) : helpText ? (
        <span className="text-xs text-muted-foreground">{helpText}</span>
      ) : null}
    </div>
  );
}

export default DropDown;
